<app-courses title="Published" status="published"></app-courses>